import React from 'react';
import { motion } from 'framer-motion';
import { useI18n } from '../lib/i18n';
import { dictionary } from '../lib/content';
export function Timeline() {
  const {
    lang,
    t
  } = useI18n();
  const items = dictionary[lang].timeline.items;
  return <section className="w-full bg-[#05060A] py-32 px-6 md:px-12" data-id="element-174">
      <div className="max-w-5xl mx-auto" data-id="element-175">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-4xl md:text-5xl font-light text-white mb-20 tracking-tight" data-id="element-176">
          {t('timeline.title')}
        </motion.h2>

        <div className="relative" data-id="element-177">
          <div className="absolute left-0 md:left-1/2 top-0 bottom-0 w-px bg-white/10" aria-hidden="true" data-id="element-178" />

          <ul className="space-y-16" data-id="element-179">
            {items.map((item, i) => <motion.li key={i} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-80px'
          }} transition={{
            duration: 0.6,
            delay: i * 0.05
          }} className={`relative pl-10 md:pl-0 md:grid md:grid-cols-2 md:gap-12 ${i % 2 === 0 ? '' : 'md:[&>div:first-child]:col-start-2'}`} data-id="element-180">
                <div className={i % 2 === 0 ? 'md:text-right md:pr-12' : 'md:pl-12'} data-id="element-181">
                  <div className="text-xs font-mono tracking-widest text-violet-400 mb-2" data-id="element-182">
                    {item.year}
                  </div>
                  <h3 className="text-xl text-white font-light mb-2" data-id="element-183">
                    {item.title}
                  </h3>
                  <p className="text-sm text-white/50 leading-relaxed" data-id="element-184">
                    {item.desc}
                  </p>
                </div>
                <span className="absolute left-0 md:left-1/2 top-1 w-2 h-2 -translate-x-1/2 md:-translate-x-1/2 rounded-full bg-violet-500 ring-4 ring-violet-500/20" aria-hidden="true" data-id="element-185" />
              </motion.li>)}
          </ul>
        </div>
      </div>
    </section>;
}